import React, { useContext } from 'react';
import AuthContext from '@xometry/auth-context';

function StaffRoute({ component: Component, pageName, ...rest }) {
  const { user, isLoading, isStaff } = useContext(AuthContext);

  window.analytics.page(pageName);

  if (isLoading) return <div />;

  if (user != null) {
    if (isStaff()) {
      return <Component {...rest} />;
    }
  }
  return <></>;
}

export default StaffRoute;
